import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

// Props

export default /*#__PURE__*/_defineComponent({
  props: {
  keyboardClass: {
    type: String,
    default: 'simple-keyboard',
  },
  input: {
    type: String,
    default: '',
  },
  numberRow: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onChange", "onKeyPress"],
  setup(__props, { emit }: { emit: ({
  (e: 'onChange', input: string): void;
  (e: 'onKeyPress', button: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



// Emits


// State
const keyboard = ref<Keyboard | null>(null);

function handleShift() {
  if (!keyboard.value) return;
  const currentLayout = keyboard.value.options.layoutName;
  const shiftToggle = currentLayout === 'default' ? 'shift' : 'default';
  keyboard.value.setOptions({
    layoutName: shiftToggle,
  });
}

function onChange(input: string) {
  emit('onChange', input);

  const currentLayout = keyboard.value?.options.layoutName;
  if (currentLayout === 'shift') {
    handleShift();
  }
}

function onKeyPress(button: string) {
  emit('onKeyPress', button);

  if (button === '{shift}' || button === '{lock}') {
    handleShift();
  }
}

onMounted(() => {
  keyboard.value = new Keyboard(props.keyboardClass, {
    onChange,
    onKeyPress,
    layout: {
      default: props.numberRow
        ? [
            '1 2 3 4 5 6 7 8 9 0',
            'q w e r t y u i o p',
            'a s d f g h j k l ñ',
            '{shift} z x c v b n m',
            '{space} {bksp}',
          ]
        : [
            'q w e r t y u i o p',
            'a s d f g h j k l ñ',
            '{shift} z x c v b n m',
            '{space} {bksp}',
          ],
      shift: props.numberRow
        ? [
            '~ ! @ # $ % ^ & * ( )',
            'Q W E R T Y U I O P',
            'A S D F G H J K L Ñ',
            '{shift} Z X C V B N M',
            '{space} {bksp}',
          ]
        : [
            'Q W E R T Y U I O P',
            'A S D F G H J K L Ñ',
            '{shift} Z X C V B N M',
            '{space} {bksp}',
          ],
    },
    display: {
      '{bksp}': '⌫',
      '{enter}': '⏎',
      '{shift}': '⇧',
      '{lock}': '⇪',
      '{space}': ' __ ',
      '{tab}': '⇥',
    },
  });

  keyboard.value.setInput(props.input);
});

// Watch input changes
watch(
  () => props.input,
  (val) => {
    if (keyboard.value) {
      keyboard.value.setInput(val);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.keyboardClass)
  }, null, 2))
}
}

})